import React from "react"

interface Props {
     onSelectImport: () => void
     onSelectManual: () => void // New callback
}

const Step1Selection = ({ onSelectImport, onSelectManual }: Props) => {
     return (
          <div className="animate__animated animate__fadeIn">
               {/* En-tête ajouté ici */}
               <div className="text-center mb-10">
                    <h2 className="fw-boldest text-gray-900 mb-2">Comment souhaitez-vous procéder ?</h2>
                    <p className="text-muted fw-semibold fs-5">Choisissez la méthode d'ajout pour votre ou vos candidat(s).</p>
               </div>

               <div className="row g-6">
                    {/* AI Import Option */}
                    <div className="col-md-6">
                         <div className="card border border-1 border-dashed border-primary bg-hover-light-primary cursor-pointer transition-all h-100" onClick={onSelectImport}>
                              <div className="card-body d-flex flex-column align-items-center text-center p-10">
                                   <div className="symbol symbol-70px mb-5">
                                        <div className="symbol-label bg-light-primary">
                                             <i className="fas fa-robot fs-2x text-primary"></i>
                                        </div>
                                   </div>
                                   <h3 className="fw-boldest mb-2">Importation</h3>
                                   <p className="text-gray-600 fs-6">
                                        Talent <strong>extrait automatiquement</strong> les coordonnées pour vous.
                                   </p>
                                   <span className="badge badge-light-primary fw-bold">Multiples candidats</span>
                              </div>
                         </div>
                    </div>

                    {/* Manual Creation Option - No longer redirects */}
                    <div className="col-md-6">
                         <div className="card border border-1 border-dashed border-info bg-hover-light-info cursor-pointer transition-all h-100" onClick={onSelectManual}>
                              <div className="card-body d-flex flex-column align-items-center text-center p-10">
                                   <div className="symbol symbol-70px mb-5">
                                        <div className="symbol-label bg-light-info">
                                             <i className="fas fa-user-edit fs-2x text-info"></i>
                                        </div>
                                   </div>
                                   <h3 className="fw-boldest mb-2">Saisie Manuelle</h3>
                                   <p className="text-gray-600 fs-6">
                                        Remplissez manuellement le formulaire pour un <strong>seul candidat</strong>.
                                   </p>
                                   <span className="badge badge-light-info fw-bold">Un seul candidat</span>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     )
}

export default Step1Selection
